"use strict";

const { filter } = require("./dashboard-graphBuilder/dataSourceFilterDirective");

function prefixKeys(obj, prefix) {
  if (!obj || typeof obj !== 'object' || !prefix) {
    return obj;
  }

  const keys = Object.keys(obj);

  if (keys.length === 0) {
    return obj;
  }

  return keys.reduce((result, key) => Object.assign(result, { [prefix + key]: obj[key] }), {});
}

function getMatchFunction({ key, key1, key2, match }) {
  if (typeof match === 'function') {
    return match;
  }

  const k1 = key1 || key;
  const k2 = key2 || key;

  if (!k1 || !k2) {
    return undefined;
  }

  return (a, b) => a[k1] === b[k2] && a[k1] !== undefined;
}


function join(array1, array2, { key, key1, key2, match, prefix1, prefix2 } = {}) {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return [];
  }

  const matchItems = getMatchFunction({ key, key1, key2, match });

  if (typeof matchItems !== 'function') {
    return [];
  }

  return array1.reduce((prev, cur) => {
    const matches = array2.filter(a2 => matchItems(cur, a2));
    return matches.length === 0
      ? prev
      : prev.concat(matches.map(m => Object.assign({}, prefixKeys(m, prefix2), prefixKeys(cur, prefix1))));
  }, []);
}



module.exports = function (
  $scope,
  $stateParams,
  Department,
  FormAPI,
  GraphAPI,
  $state,
  Integration,
  myDepartments,
  graphHttpCancel
) {
  var _this = this;
  // console.log('$state en graphDataFactory', $state)
  this.resultsSets = {};
  this.resultsFilterKeys = {};
  this.resultsPromiseKeys = {};
  this.refreshableElementIds = {};
  this.dsLoadingStatus = {};
  this.dsReadyDeferreds = {};
  this.initialPreloadActive = false;
  this.formDetailsCache = {};
  this.formDetailsPromises = {};
  this.flattenedForms = [];
  this.departmentforms = [];
  this.loadingIntegrations = false;
  this.loadingDepartments = false;
  const getElementValue = (rule, graph) => {
    try {
      let value;
      if (rule.valueType != "dynamic") return rule.value;
      value = graph?.pages?.reduce((value, page) => {
        value = page?.fields?.reduce(
          (value, field) => (field.id == rule.value ? field.value : value),
          value
        );
        return value;
      }, undefined);
      return value;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const getDataType = (fieldName, pages, defaultType = "text", validatePages = null) => {
    if (fieldName.startsWith("validate_") && validatePages && Array.isArray(validatePages)) {
      let cleanFieldId = fieldName.replace(/^validate_/, '');

      for (let page of validatePages) {
        if (page.fields && Array.isArray(page.fields)) {
          let type = page.fields.reduce((type, field) => {
            if (field.nodes)
              return getDataType(cleanFieldId, [{ fields: field.nodes }], type);
            return field.id == cleanFieldId ? field.type : type;
          }, defaultType);

          if (type !== defaultType) return type;
        }
      }
    }

    let type;
    type = pages.reduce((type, page) => {
      type = page.fields.reduce((type, field) => {
        if (field.nodes)
          return getDataType(fieldName, [{ fields: field.nodes }], type);
        return field.id == fieldName ? field.type : type;
      }, type);
      return type;
    }, defaultType);
    return type;
  };

  const walkConditions = (rule, graph, form, integration) => {
    try {
      let condition = {};
      if (rule.type === "operator") {
        let subConditions = (rule.rules || []).map((subrule) => {
          return walkConditions(subrule, graph, form, integration);
        }).filter((subCondition) => subCondition && Object.keys(subCondition).length > 0);
        if (subConditions.length == 0) return condition;

        if (rule.operator === "or") {
          condition["$or"] = subConditions;
        }

        if (rule.operator === "and") {
          condition["$and"] = subConditions;
        }
        return condition;
      } else if (integration) {

        let fieldName = rule.fieldId;
        let dataType = "text";

        let value = normalizeIntegrationFilterValue(getElementValue(rule, graph), rule.operator, rule.fieldId);
        let operator = "==";
        if (value == undefined || (Array.isArray(value) && value.length == 0))
          return condition;
        switch (rule.operator) {
          case "=":
          default:
        }
        switch (dataType) {
          case "text":
            break;
          default:
        }
        condition[fieldName] = value;
        return condition;
      } else if (rule.type === "field") {
        let value = getElementValue(rule, graph);
        let fieldName = ["_startedAt", "_createdAt", "closedAt", "memberId", "locked", "lockedBy", "lockedByItemAutonumeric", "lockedByItemId"].includes(
          rule.fieldId
        )
          ? rule.fieldId
          : "payload.".concat(rule.fieldId, ".value");
        if (rule.fieldId == "validateState" && value != undefined) {
          fieldName = "validate_lastState";

          if (value == undefined || value === null || value === "") {
            return {};
          }
          if (!Array.isArray(value))
            value = value.split("|")[0].split(",");
          else
            value = value?.map(v => v?.split("|")[0].trim());
          let cs = [];
          for (const v of value) {
            if (v == "REJECT") {
              if (rule.operator === "!=") {
                cs.push({ "validate_lastState": { "$ne": v } });
              } else {
                cs.push({ "validate_lastState": v });
              }

            } else if (v == "OK") {
              if (rule.operator === "!=") {
                cs.push({ "validate_lastState": { "$ne": v } });
              } else {
                cs.push({
                  "$and": [
                    { "validate": { "$size": parseInt(form.validate_instances) } },
                    { "validate_lastState": v }
                  ]
                });
              }
            } else if (v == "PENDING") {
              if (rule.operator === "!=") {
                // No PENDING = OK (con misma lógica que "igual a OK") O REJECT (con misma lógica que "igual a REJECT")
                cs.push({
                  "$or": [
                    {
                      "$and": [
                        { "validate": { "$size": parseInt(form.validate_instances) } },
                        { "validate_lastState": "OK" }
                      ]
                    },
                    { "validate_lastState": "REJECT" }
                  ]
                });
              } else {
                cs.push({
                  "$and": [
                    { "validate_lastState": { "$nin": ["OK", "REJECT"] } }
                  ]
                });
              }
            } else {
              if (parseInt(v) == 0)
                cs.push({
                  "$and": [
                    { "validate_lastState": { "$nin": ["REJECT"] } },
                    {
                      "$or": [
                        { "validate": { "$size": 0 } },
                        { "validate": { "$exists": false } }
                      ]
                    }
                  ]
                });
              else
                cs.push({
                  "$and": [
                    { "validate_lastState": { "$nin": ["REJECT"] } },
                    { "validate": { "$size": parseInt(v) } }
                  ]
                });

            }

          }
          if (cs.length == 1)
            return cs[0];
          return { "$or": cs };

        } else if (rule.fieldId == "validateUser") {
          fieldName = "validate.user.email";
          if (value == undefined || value === null || value === "") return {};
          if (!Array.isArray(value)) value = [value];
          if (value.length === 0) return condition;
          condition = { "validate.user.email": { "$in": value } }
          return condition;
        }
        else if (rule.fieldId == "validate_lastUser") {
          fieldName = "validate_lastUser";
          if (value == undefined || value === null || value === "") return {};
          if (!Array.isArray(value)) value = [value];
          if (value.length === 0) return condition;
          condition = { "validate_lastUser": { "$in": value } }
          return condition;
        }
        else if (rule.fieldId.startsWith("validate_")) {
          let cleanFieldId = rule.fieldId.replace(/^validate_/, '');
          let parentSimplelistId = null;
          if (form.validate_pages && Array.isArray(form.validate_pages)) {
            const findFieldPath = (fields, targetId, parentList = null) => {
              for (let field of fields) {
                if (field.id === targetId) {
                  return parentList;
                }
                if (field.type === 'simplelist' && field.nodes) {
                  let nodeFound = field.nodes.find(node => node.id === targetId);
                  if (nodeFound) {
                    return field.id;
                  }
                  let result = findFieldPath(field.nodes, targetId, field.id);
                  if (result !== undefined) return result;
                }
                if (field.type === 'group' && field.nodes) {
                  let result = findFieldPath(field.nodes, targetId, parentList);
                  if (result !== undefined) return result;
                }
              }
              return undefined;
            };

            for (let page of form.validate_pages) {
              if (page.fields && Array.isArray(page.fields)) {
                parentSimplelistId = findFieldPath(page.fields, cleanFieldId);
                if (parentSimplelistId !== undefined) {
                  break;
                }
              }
            }
          }

          if (parentSimplelistId) {
            fieldName = `validate.payload.${parentSimplelistId}.value.${cleanFieldId}.value`;
          } else {
            fieldName = `validate.payload.${cleanFieldId}.value`;
          }
        }


        let dataType = ["_startedAt", "_createdAt", "closedAt"].includes(rule.fieldId)
          ? "timestamp"
          : ["memberId"].includes(rule.fieldId)
            ? "member"
            : ["locked"].includes(rule.fieldId)
              ? "checkbox"
              : getDataType(rule.fieldId, form.pages, "text", form.validate_pages);

        let operator = "$eq";
        if (value == undefined || (Array.isArray(value) && value.length == 0))
          return condition;
        switch (rule.operator) {
          case "!=":
            operator = "$ne";
            break;
          case ">":
            operator = "$gt";
            break;
          case "<":
            operator = "$lt";
            break;
          case "<=":
            operator = "$lte";
            break;
          case ">=":
            operator = "$gte";
            break;
          case "existe":
            operator = "$exists";
            value = true;
            break;
          case "!existe":
            operator = "$exists";
            value = false;
            break;
          case "en":
            operator = "$in";
            break;
          case "startsWith":
            // se maneja más abajo con $regex
            break;
          case "=":
          default:
        }

        switch (dataType) {
          case "date":
          case "timestamp":
            if (!(value instanceof Date)) {
              const parts = value?.split("-");
              if (parts.length === 3) {
                value = new Date(Date.UTC(
                  parseInt(parts[0]),
                  parseInt(parts[1]) - 1,
                  parseInt(parts[2]),
                  0, 0, 0, 0
                ));
              } else {
                value = new Date(value.concat(" 00:00").substr(0, 16));
              }
            } else {
              value = new Date(value.getTime());
            }

            if (operator.substring(0, 3) == "$lt") {
              value.setUTCHours(23, 59, 59, 999);
            }
            if (operator.substring(0, 3) == "$gt") {
              value.setUTCHours(0, 0, 0, 0);
            }
            value = value instanceof Date ? value.toISOString() : value;
            //value = value.length > 10 ? value : (operator.substring(0, 3) == "$gt" ? value.substr(0, 10).concat("T00:00:00") : value.substring(0, 10).concat("T23:59:59"))
            if (["_startedAt", "_createdAt", "closedAt"].includes(rule.fieldId))
              value = [
                "$".concat(fieldName),
                { $dateFromString: { dateString: value } },
              ];
            else
              value = [
                {
                  $dateFromString: {
                    dateString: (rule.fieldParentId
                      ? "$$this."
                      : "$payload."
                    ).concat(rule.fieldId, ".value"),
                  },
                },
                { $dateFromString: { dateString: value } },
              ];
            fieldName = "$expr";
            break;
          case "member":
            //{ $expr : { $in: [ '$_id' , [{ $toObjectId: "56fc264402a3885f336d8d49" }] ] } }
            operator = "$in";
            value = [
              "$".concat(fieldName),
              value.map((v) => {
                return { $toObjectId: v };
              }),
            ];
            fieldName = "$expr";
            break;
          case "number":
          case "autonumeric":
            if (!Array.isArray(value))
              value = [Number(value)];
          case "text":
          case "multiple":
          case "select":
          case "autonumeric":
            operator = operator == "$ne" ? "$nin" : "$in";
            if (!Array.isArray(value)) value = [value];
            break;
          default:
        }
        if (rule.operator === "startsWith") {
          const escapeRegex = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const val = !Array.isArray(value) ? [value] : value;
          if (val.length === 0) return condition;
          condition[fieldName] = {
            $regex_in: val.map((v) => "^" + escapeRegex(v)),
          };
          return condition;
        }
        if (rule.fieldParentId) {
          let temp = `{
            "$expr": {
              "$reduce": {
                "input": "$payload.${rule.fieldParentId}.value",
                "initialValue": false,
                "in": {
                  "$or": [
                    "$$value",
                    {
                      "${operator}": ${dataType.includes("date", "timestamp")
              ? JSON.stringify(value)
              : `["$$this.${rule.fieldId}.value",${JSON.stringify(value)}]`
            }
                    }
                  ]
                }
              }
            }
          }`;
          condition = JSON.parse(temp);
        } else {
          condition[fieldName] = {};
          condition[fieldName][operator] = value;

          /*condition[fieldName][operator] = value.map(v => {
            return (typeof (v) == "string" && v.indexOf("|") > 0) ? new RegExp(`^${v.split("|")[0]}`) : v;
          });*/
        }
        return condition;
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  function filtersToMongo(filters, graph, form, integration) {
    if (filters == undefined || !Array.isArray(filters) || filters.length == 0)
      return {};

    let conditions = filters[0].conditions.reduce((filter, rule) => {
      let condition = walkConditions(rule, graph, form, integration);
      if (condition && Object.keys(condition).length > 0) {
        filter.push(condition);
      }
      return filter;
    }, []);

    let query = {};
    if (integration) {
      query = conditions.length > 0 ? (conditions.length == 1 ? conditions[0] : { $and: conditions }) : {};
    } else {
      query = conditions.length > 0 ? { $and: conditions } : {};
    }
    return query;
  }

  function filtersIntegration(filters, graph, integration) {
    if (filters == undefined || (!Array.isArray(filters) || filters.length == 0))
      return {};

    let grouped = filters[0].conditions.reduce((acc, rule) => {
      let condition = walkIntegrationConditions(rule, graph, integration);

      if (condition !== undefined && !(Array.isArray(condition) && condition.length === 0)) {
        let field = rule.fieldId;

        if (Array.isArray(condition)) {
          if (condition.length === 0) return acc;
          if (condition.length === 1) {
            if (acc[field] !== undefined) {
              acc[field] = [].concat(acc[field], condition[0]);
            } else {
              acc[field] = condition[0];
            }
          } else {
            if (acc[field] !== undefined) {
              acc[field] = [].concat(acc[field], condition);
            } else {
              acc[field] = condition;
            }
          }
        } else {
          if (acc[field] !== undefined) {
            acc[field] = [].concat(acc[field], condition);
          } else {
            acc[field] = condition;
          }
        }
      }
      return acc;
    }, {});

    Object.keys(grouped).forEach(k => {
      if (Array.isArray(grouped[k]) && grouped[k].length === 1) {
        grouped[k] = grouped[k][0];
      }
    });

    return grouped;
  }

  // Fecha de widget → ISO UTC, igual que filtersToMongo (2026-01-01T00:00:00.000Z).
  // <= / < / HASTA: fin del día (T23:59:59.999Z). Resto: inicio (T00:00:00.000Z).
  function toUtcDateOnly(value) {
    if (value instanceof Date && !isNaN(value.getTime())) {
      let y;
      let m;
      let d;
      if (value.getUTCHours() === 0 && value.getUTCMinutes() === 0 &&
          value.getUTCSeconds() === 0 && value.getUTCMilliseconds() === 0) {
        y = value.getUTCFullYear();
        m = value.getUTCMonth();
        d = value.getUTCDate();
      } else {
        y = value.getFullYear();
        m = value.getMonth();
        d = value.getDate();
      }
      return new Date(Date.UTC(y, m, d, 0, 0, 0, 0));
    }
    if (typeof value === "string") {
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        return new Date(Date.UTC(
          parseInt(match[1], 10),
          parseInt(match[2], 10) - 1,
          parseInt(match[3], 10),
          0, 0, 0, 0
        ));
      }
    }
    return null;
  }

  function isEndOfDayFilter(operator, fieldId) {
    const op = operator || "=";
    if (op === "<=" || op === "<") return true;
    if (op === ">=" || op === ">") return false;
    const field = String(fieldId || "").toLowerCase();
    return field === "hasta" || field === "until" || field === "to" || field === "end";
  }

  function formatFilterDateValue(value, operator, fieldId) {
    const date = toUtcDateOnly(value);
    if (!date) return value;
    if (isEndOfDayFilter(operator, fieldId)) {
      date.setUTCHours(23, 59, 59, 999);
    } else {
      date.setUTCHours(0, 0, 0, 0);
    }
    return date.toISOString();
  }

  function normalizeIntegrationFilterValue(value, operator, fieldId) {
    if (value === undefined || value === null || value === "") return undefined;
    if (Array.isArray(value)) {
      return value
        .map((v) => normalizeIntegrationFilterValue(v, operator, fieldId))
        .filter((v) => v !== undefined);
    }
    return formatFilterDateValue(value, operator, fieldId);
  }

  // Resuelve el valor de un filtro de integración desde cualquier widget del graph
  // (date, select, multiple, text, etc.). Antes solo se leían selects, así que
  // Desde/Hasta nunca llegaban a Integration.request ni a los DS que los concatenan.
  function walkIntegrationConditions(rule, graph, integration) {
    if (rule.valueType == 'dynamic' && rule.value) {
      return normalizeIntegrationFilterValue(getElementValue(rule, graph), rule.operator, rule.fieldId);
    }
    if (rule.valueType == 'static' && rule.value != undefined) {
      return normalizeIntegrationFilterValue(rule.value, rule.operator, rule.fieldId);
    }
    return undefined;
  }

  function flattenFilterFieldRules(filters) {
    const rules = [];
    const walk = function (list) {
      (list || []).forEach(function (rule) {
        if (!rule) return;
        if (rule.type === "field") {
          rules.push(rule);
        } else if (rule.rules) {
          walk(rule.rules);
        }
      });
    };
    (filters || []).forEach(function (group) {
      if (group && group.conditions) walk(group.conditions);
    });
    return rules;
  }

  function parseActionFilterValues(value) {
    if (value === undefined || value === null || value === "") return [];
    if (Array.isArray(value)) {
      return value.filter(function (v) {
        return v !== undefined && v !== null && v !== "";
      });
    }
    if (typeof value === "string" && value.indexOf(",") >= 0) {
      return value.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    }
    return [value];
  }

  function addResponseFilterOp(responseFilter, field, op, val) {
    if (!responseFilter[field] || typeof responseFilter[field] !== "object" || Array.isArray(responseFilter[field])) {
      responseFilter[field] = {};
    }
    if ((op === "inq" || op === "nin") && Array.isArray(responseFilter[field][op]) && Array.isArray(val)) {
      const seen = {};
      responseFilter[field][op] = responseFilter[field][op].concat(val).filter(function (v) {
        const key = String(v);
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    } else {
      responseFilter[field][op] = val;
    }
  }

  function filtersToActionParams(filters, graph) {
    const DATE_FIELDS = ["createdAt", "_createdAt"];
    const rules = flattenFilterFieldRules(filters);
    let dateFrom;
    let dateTo;
    const responseFilter = {};

    rules.forEach(function (rule) {
      if (!rule.fieldId || !rule.operator) return;
      const rawValue = getElementValue(rule, graph);
      const isDateField = DATE_FIELDS.indexOf(rule.fieldId) !== -1;

      if (isDateField) {
        if (rawValue === undefined || rawValue === null || rawValue === "") return;
        if (rule.operator === ">=" || rule.operator === ">") {
          const iso = formatFilterDateValue(rawValue, rule.operator, rule.fieldId);
          if (iso && (!dateFrom || iso > dateFrom)) dateFrom = iso;
        } else if (rule.operator === "<=" || rule.operator === "<") {
          const iso = formatFilterDateValue(rawValue, rule.operator, rule.fieldId);
          if (iso && (!dateTo || iso < dateTo)) dateTo = iso;
        } else if (rule.operator === "between") {
          const values = parseActionFilterValues(rawValue);
          if (values.length >= 2) {
            const fromIso = formatFilterDateValue(values[0], ">=", rule.fieldId);
            const toIso = formatFilterDateValue(values[1], "<=", rule.fieldId);
            if (fromIso && (!dateFrom || fromIso > dateFrom)) dateFrom = fromIso;
            if (toIso && (!dateTo || toIso < dateTo)) dateTo = toIso;
          }
        } else if (rule.operator === "=") {
          const fromIso = formatFilterDateValue(rawValue, ">=", rule.fieldId);
          const toIso = formatFilterDateValue(rawValue, "<=", rule.fieldId);
          if (fromIso && (!dateFrom || fromIso > dateFrom)) dateFrom = fromIso;
          if (toIso && (!dateTo || toIso < dateTo)) dateTo = toIso;
        }
        return;
      }

      const values = parseActionFilterValues(rawValue);
      if (values.length === 0) return;

      const field = String(rule.fieldId).trim();
      if (!field) return;

      switch (rule.operator) {
        case "=":
        case "inq":
          addResponseFilterOp(responseFilter, field, "inq", values);
          break;
        case "!=":
          if (values.length === 1) {
            addResponseFilterOp(responseFilter, field, "neq", values[0]);
          } else {
            addResponseFilterOp(responseFilter, field, "nin", values);
          }
          break;
        case "nin":
          addResponseFilterOp(responseFilter, field, "nin", values);
          break;
        case ">":
          addResponseFilterOp(responseFilter, field, "gt", values[0]);
          break;
        case ">=":
          addResponseFilterOp(responseFilter, field, "gte", values[0]);
          break;
        case "<":
          addResponseFilterOp(responseFilter, field, "lt", values[0]);
          break;
        case "<=":
          addResponseFilterOp(responseFilter, field, "lte", values[0]);
          break;
        case "like":
          addResponseFilterOp(responseFilter, field, "like", values[0]);
          addResponseFilterOp(responseFilter, field, "options", "i");
          break;
        case "regexp":
          addResponseFilterOp(responseFilter, field, "regexp", values[0]);
          break;
        case "startsWith": {
          const escapeRegex = function (s) {
            return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          };
          const pattern = values.length === 1
            ? "^" + escapeRegex(values[0])
            : "^(" + values.map(escapeRegex).join("|") + ")";
          addResponseFilterOp(responseFilter, field, "regexp", pattern);
          break;
        }
        case "between":
          if (values.length >= 2) {
            addResponseFilterOp(responseFilter, field, "between", [values[0], values[1]]);
          }
          break;
        default:
          break;
      }
    });

    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (Object.keys(responseFilter).length > 0) {
      params.responseFilter = JSON.stringify(responseFilter);
    }
    return params;
  }

  function datasourceCacheKey(element) {
    const ds = element && element.templateData && element.templateData.datasource;
    if (!ds) return "";
    if (ds.type === "integration") {
      return JSON.stringify(filtersIntegration(ds.filters, _this.graph) || {});
    }
    if (ds.type === "action") {
      return JSON.stringify({
        formId: ds.formId,
        actionId: ds.actionId,
        params: filtersToActionParams(ds.filters, _this.graph) || {},
      });
    }
    if (ds.type === "query" || ds.type === "distinct") {
      const formSelected = (_this.forms || []).find(function (form) {
        return form.id == ds.formId;
      });
      return JSON.stringify(filtersToMongo(ds.filters, _this.graph, formSelected) || {});
    }
    if (ds.type === "concatenate") {
      return (ds.otherDsIds || []).map(function (id) {
        return id + ":" + datasourceCacheKey(getElementDataSourceById(id));
      }).join("|");
    }
    if (ds.type === "relation" || ds.type === "leftRelation") {
      return [ds.leftDsId, ds.rightDsId].map(function (id) {
        return id + ":" + datasourceCacheKey(getElementDataSourceById(id));
      }).join("|");
    }
    return ds.type || "";
  }

  function storeFilteredResults(elementId, rows, cacheKey) {
    _this.resultsSets[elementId] = rows;
    _this.resultsFilterKeys[elementId] = cacheKey;
    return rows;
  }


  function addNewColumns(item, ds, validate_instances) {
    function completeValidateInstance(item,ds,instanceNumber){
      const instanceSuffix = instanceNumber == null ? "" : "_" + instanceNumber;
      item.validate = item.validate ?? [];
      let instance_idx = instanceNumber;
      if(instanceNumber==null)
        instance_idx = item.validate.length - 1;
      if (ds.elements["validateState".concat(instanceSuffix)])
        item["validateState".concat(instanceSuffix)] = item.validate.length == 0 || (item.validate.length < validate_instances && item.validate[instance_idx].state != "REJECT")
          ? (
            (formSelected.validate_type == "instance-defined" && item.validate.length < formSelected.validate_defined.length) && instanceNumber==null ?
              ("Pendiente ".concat(formSelected.validate_defined[item.validate.length].input)) : "OK"
          )
          : item.validate[instance_idx]?.state == "OK" ? "Aprobado" : item.validate[instance_idx].state == "REJECT" ? "Rechazado" : item.validate[instance_idx].state;
      if (ds.elements["validateUser".concat(instanceSuffix)] && instance_idx >= 0)
        item["validateUser".concat(instanceSuffix)] = item.validate[instance_idx]?.user?.firstName?.concat(" ", item.validate[instance_idx]?.user?.lastName);
      if (ds.elements["validateDate".concat(instanceSuffix)] && instance_idx >= 0)
        item["validateDate".concat(instanceSuffix)] = item.validate[instance_idx]?.updatedAt;
      if (ds.elements["validateComment".concat(instanceSuffix)] && instance_idx >= 0)
        item["validateComment".concat(instanceSuffix)] = item.validate[instance_idx]?.comments;
      if (
        instance_idx >= 0 &&
        item.validate[instance_idx] &&
        item.validate[instance_idx].payload
      ) {
        Object.keys(item.validate[instance_idx].payload).forEach((key) => {
          if (ds.elements["validate_".concat(key,instanceSuffix)])
            item["validate_".concat(key,instanceSuffix)] =
              item.validate[instance_idx].payload[key].value;
        });
      }
    }
    
    let formSelected = _this.forms.find(function (form) {
      return form.id == ds.formId;
    });
    
    if ((validate_instances ?? 0) > 0) {
      if (ds.elements["validateHistory"])
        item["validateHistory"] = (item.validate || []).concat(item.validate_canceled || []);
      //Esto de aca es para el ultimo estado de la validacion
      completeValidateInstance(item,ds,null)
     
      if (validate_instances > 1) {
        for (let i = 0; i < validate_instances; i++) {
          if (item.validate[i]) {
            completeValidateInstance(item,ds,i)
          }
        }
      }
      delete item.validate;
    }

    let lstFieldsId = Object.keys(item.payload);
    Object.values(ds.moreFields).forEach((newField) => {
      newField.value = "";
      let fx = newField.fx;
      fx = fx.replace(
        new RegExp("_startedAt", "g"),
        JSON.stringify(item["_startedAt"])
      );
      fx = fx.replace(
        new RegExp("_createdAt", "g"),
        JSON.stringify(item["_createdAt"])
      );
      fx = fx.replace(
        new RegExp("closedAt", "g"),
        JSON.stringify(item["closedAt"])
      );
      if (item.member) {
        fx = fx.replace(
          new RegExp("lastName", "g"),
          JSON.stringify(item.member.lastName)
        );
        fx = fx.replace(
          new RegExp("firstName", "g"),
          JSON.stringify(item.member.firstName)
        );
      }
      Object.keys(item)
        .filter((e) => e.substring(0, 8) == "validate")
        .forEach((id) => {
          fx = fx.replace(new RegExp("\\b".concat(id, "\\b"), "g"), JSON.stringify(item[id]));
        });

      fx = lstFieldsId.reduce((fx, id) => {
        //console.log(fx, id)
        fx = fx.replace(
          new RegExp("\\b".concat(id, "\\b").concat(".subItemsCount"), "g"),
          item.payload[id].value?.length
        );
        fx = fx.replace(
          new RegExp("\\b".concat(id, "\\b"), "g"),
          JSON.stringify(item.payload[id].value)
        );
        return fx;
      }, fx);
      try {
        fx=fx.replace(/validate_[a-zA-Z0-9]{9}/g, 'null'); // Por si no existe el campo que usa en la formula, no lance error.
        newField.value = eval(fx);
      } catch (error) {
        newField.value = ""; //"ERROR:0".concat(error.message);
        console.log("addNewColumns Error: ",newField.id,error.message)
      }
      item.payload[newField.id] = JSON.parse(JSON.stringify(newField));
    });
    return item;
  }

  function cleanPayloadNoCols(item, ds) {
    let lstFieldsId = Object.keys(item.payload);
    lstFieldsId.forEach((fieldId) => {
      if (
        (ds.elements[fieldId] == undefined &&
          ds.elements[item.payload[fieldId].parentId] == undefined
        ) &&
        (item.payload[fieldId].type != "graphColumn" && !item.payload[fieldId].graphColumn)
      ) {
        delete item.payload[fieldId];
      }
    });
  }

  function expandItem(item, ds) {
    // Solo busca "expand". "expanded" es marca temporal (abajo) para no re-elegir este campo en la recursión.
    let field = Object.values(ds.elements).reduce((field, ele) => {
      if (field) return field;
      if (ele.subItems && ele.subItems == "expand") return ele;
      if (
        ele.nodes &&
        Object.values(ele.nodes).find(
          (subele) => subele.subItems && subele.subItems == "expand"
        )
      )
        return Object.values(ele.nodes).find(
          (subele) => subele.subItems && subele.subItems == "expand"
        );
    }, undefined);
    if (field == undefined) return [item];

    field.subItems = "expanded"; // temporal: este campo ya no se elige en llamadas recursivas
    let ret = [];
    try {
      let cleanId = field.validate_pages ? field.id.replace(/^validate_/, '') : field.id; // si viene "validate_id" se le saca "validate_"
      let payload = field.validate_pages
        ? (Array.isArray(item.validate) && item.validate.length > 0
          ? item.validate[item.validate.length - 1]?.payload?.[cleanId]
          : null)
        : item.payload?.[field.id];
      if(payload?.type=="multiple" && payload?.value!=null && !Array.isArray(payload?.value)){ //Compatiblidad para el expandir multiple y antes era un select
        payload.value = [payload.value]; 
      }
      if (payload?.value && Array.isArray(payload.value) && payload.value.length > 0) {
        ret = payload.value.reduce((lst, value) => {
          if (value == undefined || value == null) value = "";
          let newItem = JSON.parse(JSON.stringify(item));

          if (field.type == "simplelist" && field.subItemsCols == "expand") {
            Object.keys(value).forEach((newCol) => {
              if (value[newCol] == null || typeof value[newCol] !== "object") return;
              value[newCol].parentId = field.id;

              if (field.validate_pages) {
                const nodeKey = "validate_".concat(newCol.replace(/^validate_/, ''));
                const nodeDef = (field.nodes && field.nodes[nodeKey]) || ds.elements[nodeKey] || {};
                let valueTmp = getValueByType({ ...nodeDef, ...value[newCol] });
                value[newCol].value = valueTmp // 
                newItem.validate[item.validate?.length - 1].payload[newCol.replace(/^validate_/, '')] = value[newCol]
              } else {
                newItem.payload[newCol] = value[newCol]
              }
            });

            if (field.validate_pages) {
              delete newItem.validate[item.validate?.length - 1].payload[cleanId];
            } else {
              delete newItem.payload[field.id];
            }
          } else if (["photo", "video", "docs"].includes(field.type) && value.uri) {
            if (field.validate_pages) {
              newItem.validate[item.validate?.length - 1].payload[cleanId].value = value.uri
            } else {
              newItem.payload[field.id].value = value.uri
            }
          } else {
            if (field.validate_pages) {
              newItem.validate[item.validate?.length - 1].payload[cleanId].value = value;
            } else {
              newItem.payload[field.id].value = value;
            }
          }
          lst = lst.concat(expandItem(newItem, ds));
          return lst;
        }, []);
      } else {
        let newItem = JSON.parse(JSON.stringify(item));
        if (field.validate_pages) {
          if (!Array.isArray(newItem.validate)) {
            newItem.validate = [];
          }
          if (newItem.validate.length > 0) {
            const lastValidate = newItem.validate[newItem.validate.length - 1];
            if (lastValidate?.payload?.[cleanId]) {
              lastValidate.payload[cleanId].value = "";
            }
          }
        } else {
          if (newItem.payload?.[field.id]) {
            newItem.payload[field.id].value = "";
          }
        }
        ret = expandItem(newItem, ds);
      }
    } finally {
      field.subItems = "expand"; // siempre restaurar, aunque falle el expand
    }
    return ret;
  }

  function convertirTextoATiempo(texto) {
    // Expresiones regulares para extraer días, horas, minutos y segundos del texto
    const dias = /(\d+)\s*días?/.exec(texto);
    const horas = /(\d+)\s*horas?/.exec(texto);
    const minutos = /(\d+)\s*minutos?/.exec(texto);
    const segundos = /(\d+)\s*segundos?/.exec(texto);

    // Convertir los valores a números, si existen, sino poner 0
    const diasNum = dias ? parseInt(dias[1]) : 0;
    const horasNum = horas ? parseInt(horas[1]) : 0;
    const minutosNum = minutos ? parseInt(minutos[1]) : 0;
    const segundosNum = segundos ? parseInt(segundos[1]) : 0;

    // Convertir días a horas y sumar con las horas existentes
    const totalHoras = diasNum * 24 + horasNum;

    // Asegurar que horas, minutos y segundos siempre tengan 2 dígitos
    const horasFormateadas = totalHoras.toString().padStart(2, '0');
    const minutosFormateados = minutosNum.toString().padStart(2, '0');
    const segundosFormateados = segundosNum.toString().padStart(2, '0');

    // Devolver el tiempo en formato hh:mm:ss
    return `${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
  }

  function getValueByType(field) {
    if (field == undefined || field == null) return "";
    if (field.value == undefined || field == null) return "";
    // if (field.type == "date" || field.type == "timestamp") {
    //     return new Date(field.value).toLocaleDateString("af");
    if ((field.type === "date" || field.type === "timestamp") && field.value) {
      const d = new Date(field.value);
      return isNaN(d.getTime()) ? "" : d.toLocaleDateString("af");
    } else if (field.type == "time") {
      return new Date(field.value).toLocaleTimeString("af");
    } else if (field.type == "duration" && field.convertToTime) {
      return convertirTextoATiempo(field.value);
    } else if (field.type == "checkbox" && field.convertTo != undefined) {
      switch (field.convertTo) {
        case "SI/NO":
          return field.value == true ? "SI" : "NO";
        case "1/0":
          return field.value == true ? "1" : "0";
        case "VERDADERO/FALSO":
          return field.value == true ? "VERDADERO" : "FALSO";
      }
    } else if (
      field.onlyLabel && typeof field.value == "string"
    ) {
      return field.value.substr(field.value.indexOf("|") + 1, 100);
    } else if (field.type == "geo" && field.value) {
      return "".concat(
        field.value.coords?.latitude || "",
        ",",
        field.value.coords?.longitude || ""
      );
    } else if (field.value == undefined || field.value == null) {
      return "";
    }
    else return field.value;
  }

  function processRow(item, ds) {
    const systemDateIds = ["_startedAt", "_createdAt", "closedAt", "validateDate"];
    let lstFieldsId = systemDateIds.concat(Object.keys(item.payload || {}));
    lstFieldsId.forEach((fieldId) => {
      let field = ds.elements[fieldId];
      if (field == undefined) return;
      const isSystemDate = systemDateIds.includes(fieldId);
      if (!isSystemDate && item.payload[fieldId] == undefined) return;
      const cutToDate = !!field.localeAndCutDate;
      if (field.type == "date" && item.payload[fieldId]?.value) {
        if (cutToDate)
          item.payload[fieldId].value = new Date(
            item.payload[fieldId].value
          ).toLocaleDateString("af");
      } else if (field.type == "time" && item.payload[fieldId]?.value) {
        item.payload[fieldId].value = item.payload[fieldId].value = new Date(item.payload[fieldId].value).toLocaleTimeString("af");
      } else if (isSystemDate && item[fieldId]) {
        const d = new Date(item[fieldId]);
        item[fieldId] = cutToDate ? d.toLocaleDateString("af") : d.toLocaleString("af");
      } else if (field.type == "duration" && item.payload[fieldId]?.value && field.convertToTime) {
        item.payload[fieldId].value = convertirTextoATiempo(item.payload[fieldId].value)
      } else if (field.type == "checkbox" && field.convertTo != undefined) {
        switch (field.convertTo) {
          case "SI/NO":
            item.payload[fieldId].value = item.payload[fieldId]?.value == true ? "SI" : "NO";
            break;
          case "1/0":
            item.payload[fieldId].value = item.payload[fieldId]?.value == true ? "1" : "0";
            break;
          case "VERDADERO/FALSO":
            item.payload[fieldId].value = item.payload[fieldId]?.value == true ? "VERDADERO" : "FALSO";
            break;
        }

      } else if (field.type == "timestamp" && item.payload[fieldId]?.value) {
        const d = new Date(item.payload[fieldId].value);
        item.payload[fieldId].value = cutToDate ? d.toLocaleDateString("af") : d.toLocaleString("af");
      } else if (
        ["multiple", "select"].includes(field.type) && field.onlyLabel && typeof item.payload[fieldId].value == "string"
      ) {
        item.payload[fieldId].value = item.payload[fieldId].value.substr(item.payload[fieldId].value.indexOf("|") + 1, 100);
      } else if (field.type == "geo" && item.payload[fieldId].value) {
        item.payload[fieldId].value = "".concat(
          item.payload[fieldId].value.coords?.latitude || "",
          ",",
          item.payload[fieldId].value.coords?.longitude || ""
        );
      } else if (item.payload[fieldId] && (item.payload[fieldId].value == undefined || item.payload[fieldId].value == null)) {
        item.payload[fieldId].value = "";
      }
    });
    return item;
  }

  function processResultSet(data, ds) {
    return new Promise(function (resolve, reject) {
      let items = data?.[0]?.items ?? [];
      ds.idCustom = ds.idCustom || "id";
      let itemsDst = new Map();
      let index = 0;

      function nextChunk() {
        let startTime = Date.now();

        while (index < items.length) {
          // Yield to event loop if we spend more than 30ms in this tick
          if (Date.now() - startTime > 30) {
            setTimeout(nextChunk, 0);
            return;
          }

          let item = items[index];
          index++;

          const idCustom = item[ds.idCustom] ?? item.payload[ds.idCustom]?.value;
          if (itemsDst.has(idCustom) && itemsDst.get(idCustom)[0]?.id > item?.id) {
            continue;
          } else {
            itemsDst.set(idCustom, []);
          }

          let lstFieldsId = Object.keys(item?.payload || {});

          lstFieldsId.forEach((fieldId) => {
            let field = ds.elements[fieldId];
            if (field == undefined) return;
            if (field?.type === "simplelist" && Array.isArray(item.payload?.[fieldId]?.value)) {
              if (field.subItems == "hide") {
                item.payload[fieldId].value = item.payload[fieldId].value.length;
                return;
              }
              item.payload[fieldId].value.forEach((subItem, idx) => {
                let lstSubFieldsId = Object.keys(subItem);
                let value;
                lstSubFieldsId.forEach((subFieldId) => {
                  if (field.nodes && field.nodes[subFieldId]) {
                    if (
                      field.subItems == "concatenate" ||
                      field.subItemsCols == "concatenate"
                    ) {
                      value = (value || "").concat(
                        field.nodes[subFieldId].name ||
                        field.nodes[subFieldId].label,
                        ":",
                        getValueByType(subItem[subFieldId]),
                        ";"
                      );
                    } else {
                      value = value || {};
                      value[subFieldId] = subItem[subFieldId];
                    }
                  }
                });
                if (value == undefined || value == null)
                  value = "";
                if (item.payload?.[fieldId]) {
                  item.payload[fieldId].value[idx] = value;
                }
              });
              if (field.subItems == "concatenate")
                item.payload[fieldId].value =
                  item.payload[fieldId].value.join("\n");
            } else if (
              field.type == "multiple" &&
              field.subItems == "concatenate" &&
              item.payload[fieldId] &&
              item.payload[fieldId].value
            )
              item.payload[fieldId].value = "".concat(
                item.payload[fieldId].value ? item.payload[fieldId].value.join(", ") : ""
              );
            else if (
              ["photo", "video", "docs"].includes(field.type) &&
              field.subItems == "concatenate" &&
              item.payload[fieldId] &&
              item.payload[fieldId].value
            )
              item.payload[fieldId].value = item.payload[fieldId].value.map(p => p.uri);
          });
          let itemExpanded = expandItem(item, ds);

          // Validate
          if (item.validate && item.validate.length > 0) {
            let isConcatenate = false;
            let lstFielValidate = Object.keys(item.validate[item.validate?.length - 1].payload);
            lstFielValidate.forEach((fieldId) => {
              let field = ds.elements['validate_' + fieldId];
              if (field == undefined) return;
              if (
                field.type == "simplelist" &&
                Array.isArray(item.validate[item.validate?.length - 1].payload[fieldId].value)
              ) {
                if (field.subItems == "hide") {
                  item.validate[item.validate?.length - 1].payload[fieldId].value = item.validate[item.validate?.length - 1].payload[fieldId].value.length;
                  return;
                }
                item.validate[item.validate?.length - 1].payload[fieldId].value.forEach((subItem, idx) => {
                  let lstSubFieldsId = Object.keys(subItem);
                  let value;
                  lstSubFieldsId.forEach((subFieldId) => {
                    const nodeKey = 'validate_' + subFieldId;
                    const nodeDef = (field.nodes && field.nodes[nodeKey]) || ds.elements[nodeKey];
                    if (nodeDef) {
                      if (
                        field.subItems == "concatenate" ||
                        field.subItemsCols == "concatenate"
                      ) {
                        isConcatenate = true;
                        value = (value || "").concat(
                          nodeDef.name ||
                          nodeDef.label,
                          ":",
                          getValueByType(subItem[subFieldId]),
                          ";"
                        );
                      } else {
                        value = value || {};
                        value[nodeKey] = getValueByType({ ...nodeDef, ...subItem[subFieldId] });
                      }
                    }
                  });
                  if (value == undefined || value == null) value = "";
                  item.validate[item.validate?.length - 1].payload[fieldId].value[idx] = value;
                });
                if (field.subItems == "concatenate")
                  item.validate[item.validate?.length - 1].payload[fieldId].value =
                    item.validate[item.validate?.length - 1].payload[fieldId].value.join("\n");
              } else if (
                field.type == "multiple" &&
                field.subItems == "concatenate" &&
                item.validate[item.validate?.length - 1].payload[fieldId] &&
                item.validate[item.validate?.length - 1].payload[fieldId].value
              )
                item.validate[item.validate?.length - 1].payload[fieldId].value = "".concat(
                  item.validate[item.validate?.length - 1].payload[fieldId].value ? item.validate[item.validate?.length - 1].payload[fieldId].value.join(", ") : ""
                );
              else if (
                ["photo", "video", "docs"].includes(field.type) &&
                field.subItems == "concatenate" &&
                item.validate[item.validate?.length - 1].payload[fieldId] &&
                item.validate[item.validate?.length - 1].payload[fieldId].value
              )
                item.validate[item.validate?.length - 1].payload[fieldId].value = item.validate[item.validate?.length - 1].payload[fieldId].value.map(p => p.uri);
            });
            if (isConcatenate) {
              itemExpanded = expandItem(item, ds);
            }
          }

          itemExpanded.forEach((itemChild) => {
            processRow(
              addNewColumns(itemChild, ds, data[0].validate_instances),
              ds
            );
            cleanPayloadNoCols(itemChild, ds);

          });
          itemsDst.set(idCustom, itemExpanded);
        }
        resolve(Array.from(itemsDst.values()).flatMap(v => v));
      }

      nextChunk();
    });
  }

  function itemsToTable(items, ds) {
    return new Promise(function (resolve, reject) {
      let table = [];
      let index = 0;

      function nextChunk() {
        let startTime = Date.now();

        while (index < items.length) {
          if (Date.now() - startTime > 30) {
            setTimeout(nextChunk, 0);
            return;
          }

          let item = items[index];
          index++;

          let row = {};
          let lstFieldsId = Object.keys(item);
          lstFieldsId.forEach((fieldId) => {
            if (fieldId != "payload" && ds.elements[fieldId])
              row[ds.elements[fieldId].name] = item[fieldId];
          });
          if (item.member) {
            lstFieldsId = Object.keys(item.member);
            lstFieldsId.map((fieldId) => {
              if (ds.elements[fieldId] && fieldId != "id")
                row[ds.elements[fieldId].name] = item.member[fieldId];
            });
          }

          lstFieldsId = Object.keys(item.payload);
          lstFieldsId.map((fieldId) => {
            let name = item.payload[fieldId]?.parentId
              ? ds.elements?.[item.payload[fieldId].parentId]?.nodes?.[fieldId]?.name || fieldId
              : (ds.elements?.[fieldId] || ds.moreFields?.[fieldId])?.name || fieldId;
            row[name] = item.payload[fieldId].value;
          });

          if (ds.elements.lockedBy) {
            const lockedByName = ds.elements.lockedBy.name;
            let lockedByCleared = false;
            if (ds.elements.locked) {
              const lockedRaw =
                item.locked !== undefined && item.locked !== null
                  ? item.locked
                  : item.payload && item.payload.locked
                    ? item.payload.locked.value
                    : undefined;
              if (
                lockedRaw === false ||
                lockedRaw === 0 ||
                lockedRaw === "0" ||
                lockedRaw === "false" ||
                lockedRaw === null ||
                lockedRaw === "NO" ||
                lockedRaw === "FALSO"
              ) {
                row[lockedByName] = "";
                lockedByCleared = true;
              }
            }
            if (!lockedByCleared) {
              let lockedByVal = row[lockedByName];
              if (lockedByVal == null || lockedByVal === "") {
                const auto = item.lockedByItemAutonumeric;
                const byId = item.lockedByItemId;
                if ((auto != null && auto !== "") || (byId != null && byId !== "")) {
                  row[lockedByName] = "".concat(
                    auto != null && auto !== "" ? auto : "",
                    "|",
                    byId != null && byId !== "" ? byId : ""
                  );
                }
              }
            }
          }

          row["idx"] = table.length + 1;
          table.push(row);
        }
        resolve(table);
      }

      nextChunk();
    });
  }

  function getElementDataSourceById(elementId) {
    let element = _this.graph.pages.reduce((element, page) => {
      return element
        ? element
        : page.fields.reduce((element, field) => {
          if (element) return element;
          if (field.id == elementId) return field;
        }, element);
    }, undefined);
    return element;
  }
  _this.resultsPromises = {};

  function prepareDatasourceElements(ds) {
    if (!ds || !ds.elements) {
      return ds;
    }

    const newElements = { ...ds.elements };

    for (const fieldId in ds.elements) {
      const field = ds.elements[fieldId];
      if (field.type === "simplelist" && field.subItemsCols === "expand" && field.nodes) {
        for (const nodeId in field.nodes) {
          const node = field.nodes[nodeId];
          newElements[nodeId] = {
            ...node,
            parentId: field.id
          };
        }
      }
    }

    // Validate pages: children of nested simplelists are stored as top-level
    // elements with parentId (nodes is wiped/empty on select). Rebuild nodes map.
    for (const fieldId in newElements) {
      const field = newElements[fieldId];
      if (field.type !== "simplelist") continue;
      const hasNodes = field.nodes && !Array.isArray(field.nodes) && Object.keys(field.nodes).length > 0;
      if (hasNodes) continue;
      const childNodes = {};
      for (const childId in newElements) {
        if (newElements[childId].parentId === fieldId) {
          childNodes[childId] = newElements[childId];
        }
      }
      if (Object.keys(childNodes).length > 0) {
        newElements[fieldId] = { ...field, nodes: childNodes };
      }
    }

    // Si un crash dejó subItems en "expanded", restaurar a "expand" (no buscar "expanded" en expandItem: rompería la marca temporal).
    for (const fieldId in newElements) {
      const field = newElements[fieldId];
      if (field.subItems === "expanded") {
        newElements[fieldId] = { ...field, subItems: "expand" };
      }
      if (field.nodes) {
        for (const nodeId in field.nodes) {
          if (field.nodes[nodeId]?.subItems === "expanded") {
            field.nodes[nodeId] = { ...field.nodes[nodeId], subItems: "expand" };
          }
        }
      }
    }

    ds.elements = newElements;
    return ds;
  }

  function parseActionResponsesData(data) {
    return Array.isArray(data) ? data : [];
  }

  function fetchActionResponses(formId, actionId, extraParams) {
    const params = {
      formId: formId,
      actionId: actionId,
    };
    if (extraParams) {
      if (extraParams.dateFrom) params.dateFrom = extraParams.dateFrom;
      if (extraParams.dateTo) params.dateTo = extraParams.dateTo;
      if (extraParams.responseFilter) params.responseFilter = extraParams.responseFilter;
    }
    return FormAPI.findActionsReponse(params).$promise.then(function (data) {
      return parseActionResponsesData(data);
    });
  }

  function getResponseFieldValue(item, col, fieldId) {
    if (!item.response || typeof item.response !== "object") return undefined;
    if (Object.prototype.hasOwnProperty.call(item.response, fieldId)) {
      return item.response[fieldId];
    }
    if (col.id && Object.prototype.hasOwnProperty.call(item.response, col.id)) {
      return item.response[col.id];
    }
    if (col.name && Object.prototype.hasOwnProperty.call(item.response, col.name)) {
      return item.response[col.name];
    }
    return undefined;
  }

  function getActionFormFieldValue(item, el, ds) {
    if (!el || !el.id) return undefined;
    let val = item[el.id];
    if ((val === undefined || val === null) && el.id === "_createdAt" && item.createdAt) {
      val = item.createdAt;
    }
    if ((val === undefined || val === null) && el.id === "actionId") {
      val = item.actionId || resolveActionApiId(ds);
    }
    return val;
  }

  function formatActionCellValue(val, field) {
    if (val === undefined || val === null) return undefined;
    const fieldType = field && field.type;
    if ((fieldType === "timestamp" || fieldType === "date") && val) {
      try {
        const d = new Date(val);
        if (isNaN(d.getTime())) return val;
        if (field.localeAndCutDate) {
          return d.toLocaleDateString("af");
        }
        if (fieldType === "timestamp") {
          return d.toISOString();
        }
        return val;
      } catch (e) {
        return val;
      }
    }
    return typeof val === "object" ? JSON.stringify(val) : val;
  }

  function actionResponsesToTable(items, ds) {
    let table = [];
    let elements = ds.elements || {};
    let moreFields = ds.moreFields || {};
    let selectedElements = Object.values(elements);

    items.forEach(function (item, idx) {
      let row = { idx: idx + 1 };

      selectedElements.forEach(function (el) {
        let val = getActionFormFieldValue(item, el, ds);
        if (val !== undefined && val !== null) {
          row[el.name] = formatActionCellValue(val, el);
        }
      });

      Object.keys(moreFields).forEach(function (fieldId) {
        let col = moreFields[fieldId];
        if (!col) return;
        let val = getResponseFieldValue(item, col, fieldId);
        if (val !== undefined) {
          row[col.name] = val === null ? "" : formatActionCellValue(val, col);
        }
      });

      table.push(row);
    });
    return table;
  }

  function resolveActionApiId(datasource) {
    let actionId = datasource.actionId;
    if (!actionId || actionId.toString().startsWith("idx_")) {
      return null;
    }
    return actionId;
  }

  let refreshGeneration = 0;

  const isCancelledRequest = (err) => {
    if (err === "cancelled" || err === "canceled") return true;
    if (!err) return false;
    if (err.cancelled) return true;
    if (err.status === -1 || err.status === 0) return true;
    if (err.xhrStatus === "abort" || err.xhrStatus === "timeout") return true;
    return false;
  };

  // Request abortado: no devolver [] para no vaciar la UI; sí resolver para no trabar la cadena.
  const hangIfCancelled = (err) => {
    if (isCancelledRequest(err)) {
      return { cancelled: true };
    }
    console.error(err);
    return [];
  };

  function getDataQuery(element, forceReload = false) {
   console.log('getDataQuery',forceReload == true, element);
    let datasource = element.templateData.datasource;

    // To add subitems to ds
    datasource = prepareDatasourceElements(datasource);

    let graph = _this.graph;

    let formSelected = _this.forms.find(function (form) {
      return form.id == datasource.formId;
    });
    let query = {};

    const cacheKey = datasourceCacheKey(element);
    const requestGen = refreshGeneration;

    if (element && element.id && datasource && datasource.type && datasource.type !== "distinct") {
      _this.refreshableElementIds[element.id] = true;
    }

    if (forceReload == false && Array.isArray(_this.resultsSets[element.id]) &&
        _this.resultsFilterKeys[element.id] === cacheKey)
      return new Promise((resolve, reject) => {
        resolve(_this.resultsSets[element.id]);
      });

    if (forceReload == false && _this.resultsPromises[element.id] &&
        _this.resultsPromiseKeys[element.id] === cacheKey)
      return _this.resultsPromises[element.id];

    _this.resultsPromiseKeys[element.id] = cacheKey;
    _this.resultsPromises[element.id] = new Promise((resolve, reject) => {
      // console.log('entra a resultsPromises', element)
      if ((datasource.type == 'distinct' && (element.templateData.optionsType == "member" || element.templateData.optionsType == "dynamic")) || datasource.type == 'query') {
        query = filtersToMongo(datasource.filters, graph, formSelected);
        query.formId = datasource.formId;
      }
      if (datasource.type == "distinct") {
        //Distinct Values from ONE field.
        // console.log('$stateParams.departmentId,', $stateParams.departmentId);
        if (element.templateData.optionsType == "member") {
          resolve(
            Department.teams({
              filter: {
                include: "members",
              },
              id: $stateParams.departmentId,
            }).$promise.then(function (teams) {
              let lst = {};
              teams.forEach((team) => {
                team.members.forEach((member) => {
                  if (lst[member.id] == undefined)
                    lst[member.id] = {
                      id: member.id,
                      firstName: member.firstName,
                      lastName: member.lastName,
                      email: member.email,
                    };
                });
              });
              return Object.values(lst).sort((a, b) =>
                a.email < b.email ? -1 : 1
              );
            })
          );
        } else if (element.templateData.optionsType == "dynamic") {
          if (datasource.element.id == undefined || query == undefined) {
            resolve([]);
          } else {
            let field;

            if (datasource.element.id === "validateUser") {
              field = "validate.user.email";
            } else if (datasource.element.id === "validate_lastUser") {
              field = "validate_lastUser";
            }
            else if (datasource.element.id.startsWith("validate_")) {
              let cleanFieldId = datasource.element.id.replace(/^validate_/, '');
              let parentSimplelistId = null;

              if (formSelected.validate_pages && Array.isArray(formSelected.validate_pages)) {
                const findFieldPath = (fields, targetId, parentList = null) => {
                  for (let field of fields) {
                    if (field.id === targetId) {
                      return parentList;
                    }

                    if (field.type === 'simplelist' && field.nodes) {
                      let nodeFound = field.nodes.find(node => node.id === targetId);
                      if (nodeFound) {
                        return field.id;
                      }
                      let result = findFieldPath(field.nodes, targetId, field.id);
                      if (result !== undefined) return result;
                    }

                    if (field.type === 'group' && field.nodes) {
                      let result = findFieldPath(field.nodes, targetId, parentList);
                      if (result !== undefined) return result;
                    }
                  }
                  return undefined;
                };

                for (let page of formSelected.validate_pages) {
                  if (page.fields && Array.isArray(page.fields)) {
                    parentSimplelistId = findFieldPath(page.fields, cleanFieldId);
                    if (parentSimplelistId !== undefined) {
                      break;
                    }
                  }
                }
              }
              if (parentSimplelistId) {
                field = `validate.payload.${parentSimplelistId}.value.${cleanFieldId}.value`;
              } else {
                field = `validate.payload.${cleanFieldId}.value`;
              }

            } else {
              field = "payload.".concat(datasource.element.id, ".value");
            }           

            try {
              resolve(
                GraphAPI.getDistinctItemFromFormField({
                  field: field,
                  query: JSON.stringify(query),
                  groupRepeated: element.templateData.datasource.groupRepeated || false
                })
                  .$promise.then(function (data) {
                    return data.values;
                  })
                  .catch(function (e) {
                    return hangIfCancelled(e);
                  })
              );
            } catch (e) {
              console.error(e);
            }
          }
        } else if (element.templateData.optionsType == "integration") {
          let filters = filtersIntegration(datasource.filters, graph);

          try {
            resolve(
              Integration.request(
                { integrationId: element.templateData.datasource.integrationId },
                { onlyWS: false, params: filters || undefined }
              ).$promise.then((json) => {
                return json.response;
              })
            )
          } catch (e) {
            console.error(e);
          }
        }
      } else if (datasource.type == "action") {
        let actionId = resolveActionApiId(datasource);
        if (!actionId || !datasource.formId) {
          resolve([]);
          return;
        }
        const actionParams = filtersToActionParams(datasource.filters, graph);
        resolve(
          fetchActionResponses(datasource.formId, actionId, actionParams).then(function (items) {
            if (!Array.isArray(items)) items = [];
            if (requestGen !== refreshGeneration) {
              return { cancelled: true };
            }
            let rows = actionResponsesToTable(items, datasource);
            storeFilteredResults(element.id, additionalCols(rows, element), cacheKey);
            return _this.resultsSets[element.id];
          }).catch(function (e) {
            console.error(e);
            return [];
          })
        );
      } else if (datasource.type == "query") {
        let memberFields = Object.values(datasource.elements).reduce(
          (lst, el) => {
            if (el.type == "member") lst.push(el.id);
            return lst;
          },
          []
        );
        query = {
          filter: {
            fields: ["id", "name", "validate_instances", "type", "workflow", "validate_pages", "validate_users"],
            where: {
              id: datasource.formId,
            },
            include: {
              relation: "items",
              scope: {
                limit:
                  $state.current.name ==
                    "dashboard.departments.department.graphs.gbuilder"
                    ? 100
                    : 10000,
                skip: 0,
                order: "_createdAt desc",
                where: query,
                include: [
                  memberFields.length == 0
                    ? {}
                    : { relation: "member", scope: { fields: memberFields } },
                  {
                    relation: "task",
                    scope: {
                      include: "client",
                    },
                  },
                ],
              },
            },
          },
        };
        resolve(
          FormAPI.myItems({
            formId: datasource.formId,
            departmentId: datasource.departmentId || $state.params.departmentId
          }, query).$promise.then(function (data) {
            return processResultSet(data.response || data, datasource).then(function (processedItems) {
              return itemsToTable(processedItems, datasource);
            }).then(function (rows) {
              if (requestGen !== refreshGeneration) {
                return { cancelled: true };
              }
              let scriptAdditional = "let runMe = (rows)=>{".concat(
                datasource.script || "return rows",
                "};runMe(rows);"
              );
              storeFilteredResults(element.id, eval(scriptAdditional), cacheKey);
              return _this.resultsSets[element.id];
            });
          })
            .catch(function (e) {
              return hangIfCancelled(e);
            })
        );
      }
    });
    return _this.resultsPromises[element.id];
  }

  function additionalCols(rows, element) {
    let moreCols = Object.values(element.templateData.datasource.moreFields || {});
    if (moreCols && moreCols.length > 0) {
      rows.forEach((row) => {
        moreCols.forEach((col) => {
          try {
            row[col.name] = eval(col.fx);
          } catch (error) {
            row[col.name] = "";
            console.log("additionalCols Error: ", col.id, error.message);
          }
        });
      });
    }
    let scriptAdditional = "let runMe = (rows)=>{".concat(
      element.templateData.datasource.script || "return rows",
      "};runMe(rows);"
    );
    rows = eval(scriptAdditional);
    return rows;
  }
  let lstGetDataRunning = {};

  function reuseOrStartGetData(elementId, forceReload, cacheKey, startFn) {
    const running = lstGetDataRunning[elementId];
    if (running && running.filterKey === cacheKey && running.promise) {
      return running.promise;
    }
    const requestGen = refreshGeneration;
    const promise = Promise.resolve()
      .then(function () { return startFn(requestGen); })
      .finally(function () {
        if (lstGetDataRunning[elementId] && lstGetDataRunning[elementId].promise === promise) {
          delete lstGetDataRunning[elementId];
        }
      });
    lstGetDataRunning[elementId] = { promise: promise, filterKey: cacheKey };
    return promise;
  }

  function createDeferred() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise: promise, resolve: resolve, reject: reject };
  }

  function notifyDsLoading() {
    $scope.$applyAsync(function () {
      $scope.$broadcast("graph-ds-loading");
    });
  }

  function listGraphDatasources() {
    const list = [];
    (_this.graph && _this.graph.pages || []).forEach((page) => {
      (page.fields || []).forEach((field) => {
        if (field && field.type === "datasource" && field.templateData && field.templateData.datasource) {
          list.push(field);
        }
      });
    });
    return list;
  }

  function getDatasourceDependencies(element) {
    const ds = element && element.templateData && element.templateData.datasource;
    if (!ds) return [];
    if (ds.type === "concatenate") {
      return (ds.otherDsIds || []).filter(Boolean);
    }
    if (ds.type === "relation" || ds.type === "leftRelation") {
      return [ds.leftDsId, ds.rightDsId].filter(Boolean);
    }
    return [];
  }

  function isIndependentDatasource(element) {
    const type = element && element.templateData && element.templateData.datasource &&
      element.templateData.datasource.type;
    return type === "query" || type === "distinct" || type === "action" || type === "integration" || !type;
  }

  function isRefreshableLeafDatasource(element) {
    const type = element && element.templateData && element.templateData.datasource &&
      element.templateData.datasource.type;
    return type === "query" || type === "action" || type === "integration" || !type;
  }

  function orderDependentDatasources(dependents, independents) {
    const dependentIds = {};
    dependents.forEach((el) => { dependentIds[el.id] = true; });
    const loaded = {};
    independents.forEach((el) => { loaded[el.id] = true; });
    const remaining = dependents.slice();
    const ordered = [];
    let guard = remaining.length + 2;
    while (remaining.length && guard--) {
      let progressed = false;
      for (let i = 0; i < remaining.length; ) {
        const deps = getDatasourceDependencies(remaining[i]);
        const ready = deps.every((id) => loaded[id] || !dependentIds[id]);
        if (ready) {
          ordered.push(remaining[i]);
          loaded[remaining[i].id] = true;
          remaining.splice(i, 1);
          progressed = true;
        } else {
          i++;
        }
      }
      if (!progressed) {
        remaining.forEach((el) => ordered.push(el));
        break;
      }
    }
    return ordered;
  }

  function isBuilderElementLoading(element) {
    if (!element || !_this.dsLoadingStatus) return false;
    if (element.type === "datasource") {
      const status = _this.dsLoadingStatus[element.id];
      return status === "pending" || status === "loading";
    }
    const dsId = element.templateData && element.templateData.datasourceElementId;
    if (!dsId) return false;
    const status = _this.dsLoadingStatus[dsId];
    return status === "pending" || status === "loading";
  }

  function shouldWaitForPreload(elementId, forceReload, skipFiltering) {
    if (!_this.initialPreloadActive || forceReload || skipFiltering) return false;
    const status = _this.dsLoadingStatus[elementId];
    return (status === "pending" || status === "loading") && _this.dsReadyDeferreds[elementId];
  }

  function loadOneDatasource(elementId) {
    _this.dsLoadingStatus[elementId] = "loading";
    notifyDsLoading();
    return getData(elementId, false, true, true).then(function (data) {
      _this.dsLoadingStatus[elementId] = "done";
      if (_this.dsReadyDeferreds[elementId]) {
        _this.dsReadyDeferreds[elementId].resolve(data);
      }
      notifyDsLoading();
      return data;
    }).catch(function (error) {
      console.error("graphDataFactory preload DS", elementId, error);
      _this.dsLoadingStatus[elementId] = "error";
      if (_this.dsReadyDeferreds[elementId]) {
        _this.dsReadyDeferreds[elementId].resolve([]);
      }
      notifyDsLoading();
      return [];
    });
  }

  function preloadGraphDatasources() {
    const all = listGraphDatasources();
    _this.dsLoadingStatus = {};
    _this.dsReadyDeferreds = {};
    if (!all.length) {
      _this.initialPreloadActive = false;
      return Promise.resolve();
    }
    _this.initialPreloadActive = true;
    all.forEach((el) => {
      _this.dsLoadingStatus[el.id] = "pending";
      _this.dsReadyDeferreds[el.id] = createDeferred();
    });
    notifyDsLoading();

    const independents = [];
    const dependents = [];
    all.forEach((el) => {
      if (isIndependentDatasource(el)) independents.push(el);
      else dependents.push(el);
    });
    const ordered = independents.concat(orderDependentDatasources(dependents, independents));

    return ordered.reduce(function (chain, el) {
      return chain.then(function () {
        return loadOneDatasource(el.id);
      });
    }, Promise.resolve()).then(function () {
      _this.initialPreloadActive = false;
      notifyDsLoading();
    }).catch(function (error) {
      console.error("graphDataFactory preloadGraphDatasources", error);
      _this.initialPreloadActive = false;
      notifyDsLoading();
    });
  }

  function getData(elementId, forceReload = false, skipFiltering = false, fromPreload = false) {
    if (!fromPreload && shouldWaitForPreload(elementId, forceReload, skipFiltering)) {
      return _this.dsReadyDeferreds[elementId].promise.then(function () {
        return getData(elementId, false, skipFiltering, true);
      });
    }
    console.log("graphDataFactory getData", elementId, forceReload);
    let element = getElementDataSourceById(elementId);
    if (!element || !element.templateData || !element.templateData.datasource) {
      return Promise.resolve([]);
    }
    const cacheKey = datasourceCacheKey(element);
    if (element.templateData.datasource.type == "integration") { // Integracion
      let filters = filtersIntegration(element.templateData.datasource.filters, _this.graph);
      _this.refreshableElementIds[element.id] = true;
      return reuseOrStartGetData(element.id, forceReload, cacheKey, function (requestGen) {
        return new Promise((resolve, reject) => {
          if (forceReload == false && Array.isArray(_this.resultsSets[element.id]) &&
              _this.resultsFilterKeys[element.id] === cacheKey) {
            resolve(_this.resultsSets[element.id]);
            return;
          }
          Integration.request(
            { integrationId: element.templateData.datasource.integrationId },
            { onlyWS: false, params: filters || undefined }
          ).$promise.then((json) => {
            if (requestGen !== refreshGeneration) {
              resolve({ cancelled: true });
              return;
            }
            let rows = [];
            if (!Array.isArray(json.response)) rows = [json.response];
            else rows = json.response;

            if (!skipFiltering) {
              const visibleElements = element.templateData.datasource.elements
                .filter(el => el.show !== false)
                .map(el => el.name);

              const filteredRows = rows.map(row => {
                const filteredRow = {};
                visibleElements.forEach(key => {
                  if (row.hasOwnProperty(key)) {
                    filteredRow[key] = row[key];
                  }
                });
                return filteredRow;
              });
              rows = filteredRows;
            }

            resolve(storeFilteredResults(element.id, additionalCols(rows, element), cacheKey));
          });
        });
      });
    } else if (element.templateData.datasource.type == "concatenate") { // Concatenar DS
      _this.refreshableElementIds[element.id] = true;
      return reuseOrStartGetData(element.id, forceReload, cacheKey, function (requestGen) {
        return new Promise((resolve, reject) => {
        if (forceReload == false && Array.isArray(_this.resultsSets[element.id]) &&
            _this.resultsFilterKeys[element.id] === cacheKey) {
          resolve(_this.resultsSets[element.id]);
          return;
        }
        let lstPromises = [];
        element.templateData.datasource.otherDsIds.forEach((childId) => {
          lstPromises.push(getData(childId, forceReload, true));
        });
        Promise.all(lstPromises).then((values) => {
          if (requestGen !== refreshGeneration) {
            resolve({ cancelled: true });
            return;
          }
          let rows = values.flatMap((data) => Array.isArray(data) ? data : []);

          const visibleColumnNames = Object.values(element.templateData.datasource.elements)
            .filter(el => el.show !== false)
            .map(el => el.name);

          const filteredRows = rows.map(row => {
            const filteredRow = {};

            visibleColumnNames.forEach(columnName => {
              if (row.hasOwnProperty(columnName)) {
                filteredRow[columnName] = row[columnName];
              }
            });

            if (row.idx !== undefined) {
              filteredRow.idx = row.idx;
            }

            return filteredRow;
          });

          resolve(storeFilteredResults(element.id, additionalCols(filteredRows, element), cacheKey));
        });
        });
      });
    } else if (element.templateData.datasource.type == "relation") { // Vincular DS
      _this.refreshableElementIds[element.id] = true;
      return reuseOrStartGetData(element.id, forceReload, cacheKey, function (requestGen) {
        return new Promise((resolve, reject) => {
        if (forceReload == false && Array.isArray(_this.resultsSets[element.id]) &&
            _this.resultsFilterKeys[element.id] === cacheKey) {
          resolve(_this.resultsSets[element.id]);
          return;
        }
        let lstPromises = [];
        lstPromises.push(
          getData(element.templateData.datasource.leftDsId, forceReload, true)
        );
        lstPromises.push(
          getData(element.templateData.datasource.rightDsId, forceReload, true)
        );

        Promise.all(lstPromises).then((values) => {
          if (requestGen !== refreshGeneration) {
            resolve({ cancelled: true });
            return;
          }
          let rows = join(
            values[0],
            values[1],
            {
              key1: element.templateData.datasource.leftDsKey,
              key2: element.templateData.datasource.rightDsKey
            })

          const elements = Array.isArray(element.templateData.datasource.elements)
            ? element.templateData.datasource.elements
            : Object.values(element.templateData.datasource.elements);

          const visibleElements = elements
            .filter(el => el.show !== false)
            .map(el => el.name);

          const filteredRows = rows.map(row => {
            const filteredRow = {};
            visibleElements.forEach(key => {
              if (row.hasOwnProperty(key)) {
                filteredRow[key] = row[key];
              }
            });
            return filteredRow;
          });

          resolve(storeFilteredResults(element.id, additionalCols(filteredRows, element), cacheKey));
        });
        });
      });
    } else if (element.templateData.datasource.type == "leftRelation") { // Asociar DS Secundario
      _this.refreshableElementIds[element.id] = true;
      return reuseOrStartGetData(element.id, forceReload, cacheKey, function (requestGen) {
        return new Promise((resolve, reject) => {
        if (forceReload == false && Array.isArray(_this.resultsSets[element.id]) &&
            _this.resultsFilterKeys[element.id] === cacheKey) {
          resolve(_this.resultsSets[element.id]);
          return;
        }
        let lstPromises = [];
        // skipFiltering=true: no recortar columnas de los DS hijos (los filtros de filas sí se heredan)
        lstPromises.push(
          getData(element.templateData.datasource.leftDsId, forceReload, true)
        );
        lstPromises.push(
          getData(element.templateData.datasource.rightDsId, forceReload, true)
        );
        Promise.all(lstPromises).then((values) => {
          if (requestGen !== refreshGeneration) {
            resolve({ cancelled: true });
            return;
          }
          let leftData = Array.isArray(values[0]) ? values[0] : [];
          let rightData = Array.isArray(values[1]) ? values[1] : [];
          let joinedData = [];
          leftData.forEach(leftItem => {
            let matchingRightItems = rightData.filter(rightItem => rightItem[element.templateData.datasource.rightDsKey] === leftItem[element.templateData.datasource.leftDsKey]);
            if (matchingRightItems.length > 0) {
              matchingRightItems.forEach(matchingRightItem => {
                joinedData.push({ ...leftItem, ...matchingRightItem });
              });
            } else {
              joinedData.push({ ...leftItem });
            }
          });

          const elements = Array.isArray(element.templateData.datasource.elements)
            ? element.templateData.datasource.elements
            : Object.values(element.templateData.datasource.elements);

          const visibleElements = elements
            .filter(el => el.show !== false)
            .map(el => el.name);

          const filteredRows = joinedData.map(row => {
            const filteredRow = {};
            visibleElements.forEach(key => {
              if (row.hasOwnProperty(key)) {
                filteredRow[key] = row[key];
              }
            });
            return filteredRow;
          });

          resolve(storeFilteredResults(element.id, additionalCols(filteredRows, element), cacheKey));
        }).catch(error => {
          reject(error);
        });
        });
      });
    }
    return reuseOrStartGetData(element.id, forceReload, datasourceCacheKey(element), function () {
      return getDataQuery(element, forceReload);
    });
  }

  function replaceArrayContents(target, next) {
    if (!Array.isArray(target)) return;
    target.length = 0;
    (next || []).forEach((item) => {
      target.push(item);
    });
  }

  function flattenFormsFromDepartments(departments) {
    const forms = [];
    (departments || []).forEach((department) => {
      (department.forms || []).forEach((form) => {
        if (form) forms.push(form);
      });
    });
    return forms;
  }

  function rebuildFlattenedForms() {
    if (!Array.isArray(_this.flattenedForms)) {
      _this.flattenedForms = [];
    }
    const list = [];
    (_this.departmentforms || []).forEach((department) => {
      (department.forms || []).forEach((form) => {
        if (form && form.id) {
          list.push({
            departmentName: department.name,
            formName: form.name,
            formId: form.id,
            departmentId: department.id,
          });
        }
      });
    });
    replaceArrayContents(_this.flattenedForms, list);
    return _this.flattenedForms;
  }

  function seedFormDetailsCache(forms) {
    (forms || []).forEach((form) => {
      if (form && form.id && form.pages) {
        _this.formDetailsCache[form.id] = form;
      }
    });
  }

  function notifyCatalog(kind) {
    $scope.$applyAsync(function () {
      $scope.$broadcast("graph-catalog-updated", kind);
    });
  }

  function getFormById(formId) {
    if (!formId) return Promise.resolve(undefined);
    if (_this.formDetailsCache[formId]) {
      return Promise.resolve(_this.formDetailsCache[formId]);
    }
    if (_this.formDetailsPromises[formId]) {
      return _this.formDetailsPromises[formId];
    }
    _this.formDetailsPromises[formId] = FormAPI.find({
      filter: { where: { id: formId } }
    }).$promise.then(function (forms) {
      const form = forms && forms[0];
      if (form) {
        _this.formDetailsCache[formId] = form;
      }
      return form;
    }).catch(function (error) {
      console.error("graphDataFactory getFormById", formId, error);
      return undefined;
    }).then(function (form) {
      delete _this.formDetailsPromises[formId];
      return form;
    });
    return _this.formDetailsPromises[formId];
  }

  function reloadIntegrations() {
    if (_this.integrationsReloadPromise) {
      return _this.integrationsReloadPromise;
    }
    _this.loadingIntegrations = true;
    $scope.$applyAsync();
    _this.integrationsReloadPromise = Integration.find()
      .$promise
      .then(function (integrations) {
        if (!Array.isArray(_this.integrations)) {
          _this.integrations = [];
        }
        replaceArrayContents(_this.integrations, integrations || []);
        return _this.integrations;
      })
      .catch(function (error) {
        console.error("graphDataFactory reloadIntegrations", error);
        return _this.integrations || [];
      })
      .then(function (integrations) {
        _this.loadingIntegrations = false;
        _this.integrationsReloadPromise = null;
        notifyCatalog("integrations");
        return integrations;
      });
    return _this.integrationsReloadPromise;
  }

  function reloadDepartments() {
    if (_this.departmentsReloadPromise) {
      return _this.departmentsReloadPromise;
    }
    _this.loadingDepartments = true;
    $scope.$applyAsync();
    _this.departmentsReloadPromise = myDepartments.load()
      .then(function (depts) {
        if (!Array.isArray(_this.departmentforms)) {
          _this.departmentforms = [];
        }
        replaceArrayContents(_this.departmentforms, depts || []);
        if (!Array.isArray(_this.forms)) {
          _this.forms = [];
        }
        replaceArrayContents(_this.forms, flattenFormsFromDepartments(_this.departmentforms));
        _this.formDetailsCache = {};
        _this.formDetailsPromises = {};
        rebuildFlattenedForms();
        seedFormDetailsCache(_this.forms);
        return _this.departmentforms;
      })
      .catch(function (error) {
        console.error("graphDataFactory reloadDepartments", error);
        return _this.departmentforms || [];
      })
      .then(function (departments) {
        _this.loadingDepartments = false;
        _this.departmentsReloadPromise = null;
        notifyCatalog("forms");
        return departments;
      });
    return _this.departmentsReloadPromise;
  }

  const lstResultSets = () => {
    const ids = {};
    Object.keys(_this.resultsSets || {}).forEach((id) => { ids[id] = true; });
    Object.keys(_this.refreshableElementIds || {}).forEach((id) => { ids[id] = true; });
    return Object.keys(ids);
  };

  const cancelInFlightRequests = () => {
    refreshGeneration++;
    graphHttpCancel.cancelAll();
    _this.resultsPromises = {};
    _this.resultsPromiseKeys = {};
    lstGetDataRunning = {};
  };

  const yieldToPaint = (cb) => {
    const later = function () { setTimeout(cb, 0); };
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(later);
    } else {
      later();
    }
  };

  const refreshQueries = () => {
    const gen = ++refreshGeneration;
    $scope.$applyAsync(function () {
      $scope.$broadcast("graph-reloadData-loading");
    });

    const runRefresh = function () {
      if (gen !== refreshGeneration) return;
      const all = listGraphDatasources();
      const independents = all.filter(isRefreshableLeafDatasource);
      const dependents = orderDependentDatasources(
        all.filter(function (el) { return !isIndependentDatasource(el); }),
        all.filter(isIndependentDatasource)
      );

      const loadOne = function (elementId, forceReload) {
        if (gen !== refreshGeneration) return Promise.resolve();
        return getData(elementId, forceReload).then(function (data) {
          if (data && data.cancelled) return;
          return data;
        });
      };

      Promise.all(independents.map(function (el) {
        return loadOne(el.id, true);
      }))
        .then(function () {
          if (gen !== refreshGeneration) return;
          return dependents.reduce(function (chain, el) {
            return chain.then(function () {
              return loadOne(el.id, false);
            });
          }, Promise.resolve());
        })
        .then(function () {
          if (gen !== refreshGeneration) return;
          $scope.$broadcast("graph-reloadData", false);
        })
        .catch(function (error) {
          if (gen !== refreshGeneration) return;
          if (isCancelledRequest(error)) return;
          console.error("Error:", error);
          $scope.$broadcast("graph-reloadData", false);
        });
    };

    yieldToPaint(runRefresh);
  };

  return {
    init: function (forms, graph, integrations, departmentforms) {
      _this.forms = Array.isArray(forms) ? forms : [];
      _this.graph = graph;
      _this.integrations = Array.isArray(integrations) ? integrations : [];
      _this.departmentforms = Array.isArray(departmentforms) ? departmentforms : [];
      _this.refreshableElementIds = {};
      _this.resultsSets = {};
      _this.resultsFilterKeys = {};
      _this.resultsPromises = {};
      _this.resultsPromiseKeys = {};
      lstGetDataRunning = {};
      _this.dsLoadingStatus = {};
      _this.dsReadyDeferreds = {};
      _this.initialPreloadActive = false;
      _this.formDetailsCache = {};
      _this.formDetailsPromises = {};
      _this.loadingIntegrations = false;
      _this.loadingDepartments = false;
      if (!Array.isArray(_this.flattenedForms)) {
        _this.flattenedForms = [];
      }
      rebuildFlattenedForms();
      seedFormDetailsCache(_this.forms);
    },
    getElementDataSourceById: getElementDataSourceById,
    getData: getData,
    getFormById: getFormById,
    getFlattenedForms: function () { return _this.flattenedForms; },
    reloadIntegrations: reloadIntegrations,
    reloadDepartments: reloadDepartments,
    isLoadingIntegrations: function () { return !!_this.loadingIntegrations; },
    isLoadingDepartments: function () { return !!_this.loadingDepartments; },
    preloadGraphDatasources: preloadGraphDatasources,
    isBuilderElementLoading: isBuilderElementLoading,
    itemsToTable: itemsToTable,
    processResultSet: processResultSet,
    filtersToMongo: filtersToMongo,
    lstResultSets: lstResultSets,
    refreshQueries: refreshQueries,
    cancelInFlightRequests: cancelInFlightRequests,
  };
};
